<template>
  <modal
    transition="nice-modal-fade"
    width="760"
    :adaptive="true"
    :reset="true"
    height="auto"
    :name="modalName"
    class="listing--filter-modal"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="filter--modal-card">
      <div class="filter--modal-header">
        <div class="header--bg" />

        <div class="modal--title">
          <img
            src="@/assets/img/icons/filter-white.svg"
            alt="BeliRumah Filter"
            class="modal--title-img"
          />

          <div class="modal--title-copy">
            <div class="modal--title-top">
              {{ $t('general.filterText') }}
            </div>
            <div class="modal--title-bottom">
              {{ $t('search.filter.desc') }}
            </div>
          </div>
        </div>

        <button type="button" class="modal--close-btn" @click="close">
          <img src="@/assets/img/search/cancel.svg" alt="Close" />
        </button>
      </div>

      <div class="filter--modal-body">
        <div class="body--content">
          <div class="filter--section">
            <div class="section--title">
              {{ $t('general.filter.listingType') }}
            </div>

            <div class="filter--listing-type">
              <button
                type="button"
                class="filter--option-btn"
                :class="{ active: localType === null }"
                @click="setListingType(null)"
              >
                {{ $t('general.all') }}
              </button>

              <button
                type="button"
                class="filter--option-btn"
                :class="{ active: localType === 'S' }"
                @click="setListingType('S')"
              >
                {{ $t('general.sell') }}
              </button>

              <button
                type="button"
                class="filter--option-btn"
                :class="{ active: localType === 'R' }"
                @click="setListingType('R')"
              >
                {{ $t('general.R') }}
              </button>
            </div>
          </div>

          <div class="filter--section filter--section-property">
            <div class="section--title">
              {{ $t('general.filter.propertyType') }}
            </div>

            <div class="filter--property-type">
              <button
                v-for="propertyType in filteredPropertyTypes"
                :key="`listing-filter-property-type-${propertyType.id}`"
                type="button"
                class="single--type"
                :class="{ 'active--type': isSelected(propertyType) }"
                @click="togglePropertyType(propertyType)"
              >
                <div class="single--type-content">
                  <img :src="getPropertyTypeImage(propertyType)" :alt="propertyType.name" />
                  <div class="single--type-label">
                    {{ propertyType.name }}
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="filter--modal-footer">
        <button type="button" class="reset--button" @click="resetFilter">
          {{ $t('general.filter.clearAllFilter') }}
        </button>

        <button type="button" class="btn btn-primary apply--button" @click="applyFilter">
          {{ $t('general.filter.apply') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'listing-filter-modal',
  data() {
    return {
      modalName: 'listing-filter-modal',
      localType: null,
      localSelectedPropertyTypes: [],
    };
  },
  computed: {
    ...mapState({
      type: (state) => state.listing.type,
      selectedPropertyTypes: (state) => state.listing.selectedPropertyTypes,
    }),
    ...mapGetters({
      propertyTypesByListingType: 'masters/propertyTypesByListingType',
    }),
    filteredPropertyTypes() {
      return this.propertyTypesByListingType.filter((propertyType) => {
        return propertyType && propertyType.id !== null && propertyType.id !== -1;
      });
    },
  },
  methods: {
    beforeOpen() {
      document.body.classList.add('is-listing-filter-modal-open');
      this.localType = this.type;
      this.localSelectedPropertyTypes = JSON.parse(
        JSON.stringify(this.selectedPropertyTypes || []),
      );
    },
    beforeClose() {
      document.body.classList.remove('is-listing-filter-modal-open');
    },
    close() {
      this.$modal.hide(this.modalName);
    },
    setListingType(type) {
      this.localType = type;
    },
    isSelected(propertyType) {
      return this.localSelectedPropertyTypes.some((item) => item.id === propertyType.id);
    },
    togglePropertyType(propertyType) {
      if (this.isSelected(propertyType)) {
        this.localSelectedPropertyTypes = this.localSelectedPropertyTypes.filter(
          (item) => item.id !== propertyType.id,
        );
      } else {
        this.localSelectedPropertyTypes.push(propertyType);
      }
    },
    getPropertyTypeImage(propertyType) {
      if (propertyType.image) return propertyType.image;

      const baseUrl = 'https://beliruma.b-cdn.net/public/static/img/property-type/v2';
      const imageMap = {
        1: 'house.svg',
        2: 'apartment.svg',
        3: 'warehouse.svg',
        4: 'shophouse.svg',
        5: 'residential-land.svg',
        6: 'commercial-land.svg',
        7: 'working-space.svg',
        9: 'villa.svg',
        10: 'building.svg',
        11: 'office.svg',
        12: 'factory.svg',
        13: 'commercial-land.svg',
      };

      if (imageMap[propertyType.id]) {
        return `${baseUrl}/${imageMap[propertyType.id]}`;
      }

      return `${baseUrl}/house.svg`;
    },
    resetFilter() {
      this.localType = null;
      this.localSelectedPropertyTypes = [];
    },
    async applyFilter() {
      this.$store.commit('listing/SET_TYPE', this.localType);
      this.$store.commit('listing/SET_SELECTED_PROPERTY_TYPES', this.localSelectedPropertyTypes);
      this.$store.commit('listing/SET_PAGE', 1);
      await this.$store.dispatch('listing/getAllListings', {});
      this.close();
    },
  },
  beforeDestroy() {
    document.body.classList.remove('is-listing-filter-modal-open');
  },
};
</script>

<style lang="scss">
@import '../../../assets/scss/utils/variables';

.listing--filter-modal {
  z-index: 2147483647 !important;
  display: flex;
  align-items: center;
  justify-content: center;

  .v--modal {
    width: min(760px, calc(100vw - 32px)) !important;
    max-height: calc(100vh - 32px);
    overflow: visible;
    background: transparent;
    box-shadow: none;

    @supports (height: 100dvh) {
      max-height: calc(100dvh - 32px);
    }
  }

  .filter--modal-card {
    position: relative;
    display: flex;
    width: 100%;
    max-height: calc(100vh - 32px);
    flex-direction: column;
    overflow: hidden;
    border: 1px solid rgba(24, 24, 27, 0.08);
    border-radius: 18px;
    background: $color-white;
    box-shadow: 0 24px 70px rgba(24, 24, 27, 0.24);

    @supports (height: 100dvh) {
      max-height: calc(100dvh - 32px);
    }
  }

  .filter--modal-header {
    position: relative;
    display: flex;
    min-height: 96px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    padding: 20px 56px;
    border-radius: 18px 18px 0 0;
    background: #a21515;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;
      height: 100%;
      border-top-left-radius: 1rem;
      background: $color-beliruma-1;
      content: '';
    }

    &::after {
      position: absolute;
      top: 0;
      left: calc(50% - 1.2rem);
      width: 3rem;
      height: 100%;
      border-radius: 0 100% 100% 0 / 0 50% 50% 0;
      background: $color-beliruma-1;
      content: '';
    }

    .header--bg {
      position: absolute;
    }

    .modal--title {
      position: relative;
      z-index: 2;
      display: flex;
      min-width: 0;
      align-items: center;
      gap: 16px;
    }

    .modal--title-img {
      width: 30px;
      height: 30px;
      flex: 0 0 30px;
    }

    .modal--title-copy {
      min-width: 0;
    }

    .modal--title-top {
      color: $color-white;
      font-family: Poppins-Bold, sans-serif;
      font-size: 20px;
      line-height: 1.3;
      text-transform: uppercase;
    }

    .modal--title-bottom {
      max-width: 430px;
      margin-top: 2px;
      color: $color-white;
      font-size: 13px;
      line-height: 1.5;
    }

    .modal--close-btn {
      position: relative;
      z-index: 2;
      display: flex;
      width: 40px;
      height: 40px;
      flex: 0 0 40px;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: none;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.14);
      cursor: pointer;
      transition: background-color 0.15s ease, transform 0.15s ease;

      &:active {
        transform: scale(0.96);
      }

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .filter--modal-body {
    min-height: 0;
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    width: 100%;
    background: #fafafa;
  }

  .body--content {
    width: 100%;
    padding: 24px 56px 28px;
  }

  .filter--section {
    margin-bottom: 28px;
    padding: 18px;
    border: 1px solid rgba(24, 24, 27, 0.08);
    border-radius: 16px;
    background: $color-white;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section--title {
    margin-bottom: 16px;
    color: $color-text-black;
    font-family: Poppins-Bold, sans-serif;
    font-size: 16px;
    line-height: 1.4;
  }

  .filter--listing-type {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;

    .filter--option-btn {
      width: 100%;
      min-width: 0;
      height: 40px;
      padding: 0 14px;
      border: 1px solid $color-text-black;
      border-radius: 12px;
      background-color: $color-white;
      color: $color-text-black;
      font-family: Poppins-SemiBold, sans-serif;
      font-size: 14px;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

      &:active {
        transform: scale(0.98);
      }

      &.active {
        border-color: $color-beliruma-1;
        background-color: $color-beliruma-1;
        color: $color-white;
      }
    }
  }

  .filter--property-type {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;

    .single--type {
      display: flex;
      width: 100%;
      min-width: 0;
      min-height: 78px;
      align-items: center;
      justify-content: center;
      padding: 12px 10px;
      border: 1px solid rgba(24, 24, 27, 0.16);
      border-radius: 12px;
      background-color: $color-white;
      box-shadow: 0 8px 20px rgba(24, 24, 27, 0.06);
      color: $color-text-black;
      text-align: center;
      cursor: pointer;
      transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease,
        transform 0.15s ease;

      &:active {
        transform: scale(0.98);
      }

      .single--type-content {
        width: 100%;
        min-width: 0;
      }

      img {
        display: block;
        width: 22px;
        height: 22px;
        margin: 0 auto 6px;
        object-fit: contain;
      }

      .single--type-label {
        display: -webkit-box;
        overflow: hidden;
        font-family: Poppins-SemiBold, sans-serif;
        font-size: 13px;
        line-height: 1.35;
        word-break: break-word;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      &.active--type {
        border-color: $color-beliruma-1;
        background-color: $color-beliruma-1;
        color: $color-white;

        img {
          filter: brightness(0) saturate(100%) invert(100%);
        }
      }
    }
  }

  .filter--modal-footer {
    display: flex;
    min-height: 76px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 16px 56px;
    border-top: 1px solid rgba(24, 24, 27, 0.08);
    background: $color-white;

    .reset--button {
      padding: 8px 4px 8px 0;
      border: none;
      background: transparent;
      color: $color-beliruma-1;
      font-family: Poppins-SemiBold, sans-serif;
      font-size: 14px;
      cursor: pointer;
    }

    .apply--button {
      min-width: 136px;
      min-height: 42px;
      padding: 0 24px;
      border-radius: 12px;
      font-family: Poppins-SemiBold, sans-serif;
    }
  }

  @media #{$tablets} {
    .filter--modal-header {
      min-height: 90px;
      padding: 18px 40px;
    }

    .body--content {
      padding-right: 40px;
      padding-left: 40px;
    }

    .filter--modal-footer {
      padding-right: 40px;
      padding-left: 40px;
    }
  }

  @media #{$phones} {
    align-items: center;
    padding: 12px;

    .v--modal {
      left: 50% !important;
      width: min(360px, calc(100vw - 40px)) !important;
      max-height: calc(100vh - 24px);
      transform: translateX(-50%);

      @supports (height: 100dvh) {
        max-height: calc(100dvh - 24px);
      }
    }

    .filter--modal-card {
      max-height: calc(100vh - 24px);
      border-radius: 18px;

      @supports (height: 100dvh) {
        max-height: calc(100dvh - 24px);
      }
    }

    .filter--modal-header {
      min-height: auto;
      padding: 16px;
      border-radius: 18px 18px 0 0;

      &::before {
        width: 58%;
        border-top-left-radius: 14px;
      }

      &::after {
        left: calc(58% - 1rem);
        width: 2.5rem;
      }

      .modal--title {
        gap: 12px;
      }

      .modal--title-img {
        width: 26px;
        height: 26px;
        flex-basis: 26px;
      }

      .modal--title-top {
        font-size: 17px;
        text-transform: none;
      }

      .modal--title-bottom {
        max-width: 230px;
        margin-top: 4px;
        font-size: 12px;
        line-height: 1.45;
      }

      .modal--close-btn,
      .modal--close-btn img {
        width: 36px;
        height: 36px;
      }

      .modal--close-btn {
        flex-basis: 36px;
      }
    }

    .body--content {
      padding: 16px;
    }

    .filter--section {
      margin-bottom: 14px;
      padding: 14px;
      border-radius: 14px;
    }

    .section--title {
      margin-bottom: 12px;
      font-size: 15px;
    }

    .filter--listing-type {
      gap: 8px;

      .filter--option-btn {
        height: 42px;
        padding: 0 8px;
        border-radius: 10px;
        font-size: 13px;
      }
    }

    .filter--property-type {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;

      .single--type {
        min-height: 82px;
        padding: 12px 8px;
        border-radius: 12px;

        img {
          width: 20px;
          height: 20px;
          margin-bottom: 5px;
        }

        .single--type-label {
          font-size: 12px;
        }
      }
    }

    .filter--modal-footer {
      min-height: 76px;
      gap: 10px;
      padding: 12px 16px 16px;
      box-shadow: 0 -12px 28px rgba(24, 24, 27, 0.08);

      .reset--button {
        display: inline-flex;
        min-width: 0;
        min-height: 44px;
        flex: 1 1 0;
        align-items: center;
        justify-content: center;
        padding: 0 12px;
        border: 1px solid rgba(200, 25, 25, 0.22);
        border-radius: 12px;
        font-size: 13px;
        text-align: center;
      }

      .apply--button {
        min-width: 0;
        min-height: 44px;
        flex: 1.25 1 0;
        padding: 0 18px;
      }
    }
  }

  @media #{$small-phones} {
    .v--modal {
      width: calc(100vw - 32px) !important;
    }

    .filter--modal-header {
      padding: 14px;

      .modal--title {
        gap: 10px;
      }

      .modal--title-bottom {
        max-width: 185px;
      }
    }

    .body--content {
      padding: 14px;
    }

    .filter--property-type {
      gap: 8px;
    }

    .filter--modal-footer {
      padding: 12px 14px 14px;

      .apply--button {
        min-width: 0;
      }
    }
  }
}

body.is-listing-filter-modal-open .tawk-mobile,
body.is-listing-filter-modal-open iframe[title*='chat' i],
body.is-listing-filter-modal-open iframe[title*='tawk' i] {
  display: none !important;
}
</style>
